import $ from 'jquery';

function changeMenuTheme() {
    const triggerLight = $('.js-change-menu-t-light');
    const triggerDark = $('.js-change-menu-t-dark');
    const target = $('body');

    const classToToggle = 't-dark';

    triggerLight.on('click', function() {

        const targetHasClass = target.hasClass(classToToggle);

        if (targetHasClass) {
            target.removeClass(classToToggle);
            triggerDark.removeClass('is-active');
            $(this).addClass('is-active');
        }
    });

    triggerDark.on('click', function() {

        const targetHasClass = target.hasClass(classToToggle);

        if (!targetHasClass) {
            target.addClass(classToToggle);
            triggerLight.removeClass('is-active');
            $(this).addClass('is-active');
        }
    });
}

function changeSkin() {
    const trigger = $('.js-change-skin');
    const target = $('.o-header__bg');

    trigger.on('click', function() {
        let bg = $(this).data('image-source');
        $(this).find('input').prop( "checked", true );

        target.css('opacity', '0');
        setTimeout(function() {
            target.css('background-image', 'url(' + bg + ')');
        },300);
        setTimeout(function() {
            target.css('opacity', '1');
        },500);
    });

}

function init() {
    if ($('.js-change-menu-t-light').length > 0) {
        changeMenuTheme();
    }

    if ($('.js-change-skin').length) {
        changeSkin();
    }
}

export { init };


// WEBPACK FOOTER //
// ./src/_app/layout/user-layout.js